module.exports = __webpack_public_path__ + "static/img/slide1.aeea3e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slide1.jpg
// module id = 8XQh
// module chunks = 7